<!--
  - Copyright Huesik (c) 2019.
  -->

<template>
  <main-layout :classes="`home-view`">
    <main-menu-header></main-menu-header>
    <div class="main-wrapper">
      <section>
        <div class="overlay not-show-sm" ></div>
        <article>
          <div class="information-container not-show-sm" >
            <h2>NO. 1 고시원 정보 브랜드</h2>
            <h1>고시원 쉽게 찾기</h1>
            <p>OO동, OO역, 대학교 등 원하는 지역을 검색해보세요.</p>
          </div>
          <img src="../assets/images/logo@3x.png" class="mobile-logo show-sm-only" />
          <div class="search-container">
            <p class="search-input-wrapper">
              <search-bar :place-change="getPlaceData" :height="isSmallScreen ? 50 : 60"/>
            </p>
            <p class="ranking-list-wrapper show-lg-only" >
              <ranking-list />
            </p>
          </div>
          <ranking-list class="not-show-lg"/>
        </article>
      </section>
      <section>
        <article>
          <main-banner class="not-show-sm" />
          <package-list
            :view-type="!isSmallScreen ? 'grid' : 'row'"
            :item-count="!isSmallScreen ? 6 : 2"
            :slide-to-show="!isSmallScreen ? 1 : 1"
            :title="'추천 고시원'"
            :nav-buttons="!isSmallScreen && !isiPad"
          />
          <main-banner class="main-banner-mobile show-sm-only"/>
          <event-banner />  
          <!-- <div class="flex sub-banner-list">
            <event-banner />
            <notice />
          </div> -->
          <download-banner class="not-show-sm" />
          <!--<div class="flex sub-banner-list">-->
            <!--<info-banner />-->
            <!--<info-banner />-->
          <!--</div>-->
        </article>
        <default-footer class="main-footer" />
      </section>
    </div>
  </main-layout>
</template>

<script>
  import MainLayout from '../components/Layout/MainLayout'
  // import KosiwonInquiryHeader from '../components/Header/KosiwonInquiryHeader'
  import EventBanner from '../components/Banners/EventBanner'
  import MainMenuHeader from '../components/Header/MainMenuHeader'
  import SearchBar from '../components/Search/SearchBar'
  import RankingList from '../components/Suggestion/RankingList'
  import MainBanner from '../components/Banners/MainBanner'
  import PackageList from '../components/Suggestion/PackageList'
  import DownloadBanner from '../components/Banners/DownloadBanner'
  import DefaultFooter from '../components/Footer/index'
  import Url from '../utils/Url'
  import Utils from '../utils/Utils'
  import DynamicNavigator from '../core/modules/DynamicNavigator'
  import {mapState} from 'vuex'

  export default {
    name: 'Home',
    components: {
      DefaultFooter,
      DownloadBanner,
      PackageList,
      MainBanner,
      RankingList,
      SearchBar,
      MainMenuHeader,
      MainLayout,
      EventBanner
    },
    data: () => {
      return {
        menu: undefined,
        intervalItem: undefined
      }
    },
    computed: {
      isSmallScreen() {
        console.log(`Utils.isSmallScreen() : ${Utils.isSmallScreen()}`)
        return Utils.isSmallScreen()
      },
      isMediumScreen () {

        return Utils.isMediumScreen()
      },
      isiPad () {
        console.log(`Utils.isiPad() : ${Utils.isiPad()}`)
        return Utils.isiPad()
      },
      ...mapState({
        centerState: state => state.MAPS.CENTER
      })
    },
    watch: {
      centerState (newVal) {
        // alert(newVal)
        setTimeout(() => {
          DynamicNavigator.getInstance().moveToMap(`/search?${Url.objectToQueryString(newVal)}`, this.$router)
        }, 100)
      }
    },
    methods: {
      getPlaceData (place) {
        console.log(place)
        const latlng = {
          latitude: place.latitude,
          longitude: place.longitude
        }

        // this.$store.dispatch('setSearchLat', latlng.latitude)
        // this.$store.dispatch('setSearchLng', latlng.longitude
        this.$store.dispatch('setMapCenter', latlng)
        this.$store.dispatch('setRankingIsHide', false)
        // this.$router.push(`/search?${Url.objectToQueryString(latlng)}`)
        // DynamicNavigator.getInstance().moveToMap(`/search?${Url.objectToQueryString(latlng)}`, this.$router)
      }
    },
    mounted () {
      // this.menu = this.$refs.menuController
      // console.log(this.menu.getAttribute('isOpen'))
      // console.log(this.$ionic.menuController.open('start'))
      // this.openFirst()
      console.log(this.$mq)

      if (!(window.isNativeApp && window.isNativeApp() && this.$store.state.APP.FIRST_LOADING)) {
        this.$store.dispatch('setNetworkIndicator', true)
      } else {
        this.$store.dispatch('setAppFirstLoading', false)
      }

      this.$store.dispatch('setRankingIsHide', false)
      let count = 0
      try {
        if (window.isNativeApp && window.isNativeApp()) {
          this.intervalItem = setInterval(() => {
            if (!window.hasOwnProperty('cordova')) {
              clearInterval(this.intervalItem)
            }

            if (count > 10) {
              clearInterval(this.intervalItem)
            }

            if (window.cordova.hasOwnProperty('exec')) {
              window.cordova.exec((obj) => {
                console.log(obj)
              }, (error) => {
                console.log(error)
              }, 'CheckNative', 'hideNativeIndicator')
              clearInterval(this.intervalItem)
            } else {
              count++
            }
          }, 1000)
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
</script>

<style scoped lang="less">
  @import "../assets/css/palette";

  .home-view {
    height: 100vh;
    overflow: hidden;
  }

  .main-wrapper {
    display: flex;
    height: 100%;
  }

  section {
    width: 50%;
    height: 100%;
    &:nth-child(1) {
      position:relative;
      background: url("../assets/images/main-background.png") no-repeat no-repeat;
      background-size: cover;
      .overlay {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        background-color: white;
        opacity: .4;
      }

      .information-container {
        padding: 2.4rem;
        margin-top: 9.6rem;
        position: relative;
        h2 {
          font-size: 2.4rem;
          padding: 0 0 1.2rem;
          margin: 0;
        }
        h1 {
          font-size: 4rem;
          font-weight: bold;
          padding: 1.2rem 0 1.4rem;
          margin: 0;
        }

        p {
          font-size: 1.6rem;
          padding: 1.4rem 0 0 0;
          margin: 0;
        }
      }

      .search-container {
        max-width: 54rem;
        margin: auto;
        box-sizing: border-box;
        .search-input-wrapper {
          border-bottom: 2px solid @windows-blue;
        }
      }
    }

    &:nth-child(2) {
      background: @very-light-pink;
      padding: 4.75rem 2%;
      overflow-x: hidden;
      overflow-y: auto;
      article {
        padding-bottom: 4.4rem;
        border-bottom: 2px solid @very-light-pink-two;

        .sub-banner-list {
          justify-content: space-between;
          overflow:hidden;
          padding-top: 3rem;
          flex: 1;
        }
      }
    }
  }
  /*.main-footer {*/
    /*padding: 3.85rem 0 6.8rem 0;*/
  /*}*/
</style>

<!-- Tablet Media Query -->
<style scoped lang="less">
  @media screen and (max-width: 1440px) {
    section:nth-child(1) .information-container {
      margin-top: 2.6rem;
    }
  }
</style>

<!-- Tablet Media Query -->
<style scoped lang="less">
  @media screen and (max-width: 1366px) {
    .home-view {
      height: auto;
      overflow: initial;
      /*overflow: auto;*/
      -webkit-overflow-scrolling: touch;
      .main-wrapper {
        display: block;
        section {
          width: 100%;
          height: auto;
          &:nth-child(1) {
            background-size: cover;
          }
          &:nth-child(2) {
            padding-left: 0;
            padding-right: 0;
            overflow: initial;
            max-width: 85rem;
            margin: 0 auto;
            padding-top:0;
          }
          article {
            .information-container {
              margin: 0;
              padding-top: 5rem;
            }
          }
        }
      }
    }

  }
</style>

<style scoped lang="less">
  @import "../assets/css/palette";
  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (max-width: 768px) {
    .home-view {
      height: auto;
      overflow: initial;
      .main-wrapper {
        section {
          &:nth-child(2) {
            article {
              padding: 0 1rem;

              .sub-banner-list {
                padding-top: 0;
                padding-bottom: 2.2rem;
                > div {
                  &:first-child{
                    margin-right: 0;
                  }
                  &:last-child{
                    margin-left: 0;
                  }
                }
              }
            }
          }
        }
      }
    }
    .mobile-logo {
      padding: 2.5rem 0;
      max-width: 20rem;
      margin: 0 auto;
    }
    .search-container {
      .search-input-wrapper {
        margin: 0 1rem;
        border: 2px solid @windows-blue;
      }
    }
    .main-banner-mobile {
      margin: 2rem 0;
    }
  }
</style>
